import { render } from "./Right.vue?vue&type=template&id=3f747942&scoped=true"
import script from "./Right.vue?vue&type=script&lang=js"
export * from "./Right.vue?vue&type=script&lang=js"

import "./Right.vue?vue&type=style&index=0&id=3f747942&scoped=true&lang=css"

import exportComponent from "D:\\zhwf\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f747942"]])

export default __exports__